var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 143,
    viewBox: "0 0 165 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.9568 120.283C114.106 120.283 140.98 93.4089 140.98 60.1416C140.98 26.8743 114.106 0 80.9568 0C47.8079 0 20.9336 26.8743 20.9336 60.1416C20.9336 93.4089 47.8079 120.283 80.9568 120.283Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7986 28.2949H122.157C125.59 28.2949 128.195 30.8995 128.195 34.3328V88.4365C128.195 91.8698 125.59 94.4744 122.157 94.4744H36.7986C33.3653 94.4744 30.7607 91.8698 30.7607 88.4365V34.3328C30.7607 30.8995 33.6021 28.2949 36.7986 28.2949Z",
    fill: "url(#paint0_linear_13352_2005)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13352_2005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.831 34.3286L112.556 92.7394C112.556 94.7348 110.924 96.2767 108.928 96.2767H51.9688C49.9734 96.2767 48.3408 94.6441 48.3408 92.7394V17.6398C48.3408 15.6444 49.9734 14.1025 51.9688 14.1025H93.2373L111.831 34.3286Z",
    fill: "url(#paint1_linear_13352_2005)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2562 26.3475H57.9555C57.3206 26.3475 56.7764 25.8033 56.7764 25.1684C56.7764 24.5335 57.3206 23.9893 57.9555 23.9893H85.2562C85.8911 23.9893 86.4353 24.5335 86.4353 25.1684C86.4353 25.8033 85.8911 26.3475 85.2562 26.3475Z",
    fill: "#D5DDEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4767 32.8777H57.9555C57.3206 32.8777 56.7764 32.3335 56.7764 31.6986C56.7764 31.0637 57.3206 30.5195 57.9555 30.5195H68.386C69.0209 30.5195 69.5651 31.0637 69.5651 31.6986C69.5651 32.3335 69.0209 32.8777 68.4767 32.8777Z",
    fill: "#D5DDEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2373 14.1025V30.2471C93.2373 32.5146 95.2327 34.3286 97.5002 34.3286H111.831",
    fill: "#D5DDEA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.231 46.6699H94.3337H91.8804H58.2961C57.8732 46.6699 57.4502 47.0938 57.4502 47.6872C57.4502 48.1959 57.7886 48.7045 58.2961 48.7045H91.8804H94.3337H104.147C104.739 48.7045 105.077 48.2806 105.077 47.6872C105.077 47.1786 104.739 46.6699 104.231 46.6699Z",
    fill: "#D5DDEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.852 62.9828V89.6203C129.852 93.0536 127.129 95.8949 123.577 95.8949H35.8508C32.4175 95.8949 29.5762 93.0536 29.5762 89.6203V60.7334",
    stroke: "#1676EE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.393 48.0654H94.6901C91.9672 48.0654 89.3626 49.0125 87.35 50.67L80.1283 56.5894C78.1157 58.2469 75.5111 59.194 72.7882 59.194H41.5335C38.337 59.194 35.7324 61.7986 35.7324 64.9951C35.7324 65.2318 35.7324 65.587 35.8508 65.8238L41.6519 96.3681C42.1254 99.2095 44.4932 101.34 47.4529 101.34H114.343C117.184 101.34 119.67 99.3279 120.144 96.4865L128.194 54.6952C128.786 51.4987 126.655 48.6574 123.459 48.0654C122.985 48.0654 122.63 48.0654 122.393 48.0654Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13352_2005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.825 39.8967H98.8344C95.2828 39.8967 91.9679 41.0806 89.2449 43.33L79.7738 51.0253C77.1693 53.1563 73.736 54.4586 70.1843 54.4586H29.4585C25.3149 54.4586 22 57.8918 22 61.9171C22 62.2722 22 62.6274 22.1184 62.9826L29.5769 102.88C30.1688 106.668 33.3653 109.391 37.0354 109.391H124.17C127.958 109.391 131.036 106.786 131.628 102.998L142.165 48.4207C142.875 44.2771 140.152 40.607 136.009 39.7783C135.653 39.8967 135.18 39.8967 134.825 39.8967Z",
    fill: "url(#paint2_linear_13352_2005)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.208 35.8895C141.473 35.8895 143.308 34.0538 143.308 31.7895C143.308 29.5251 141.473 27.6895 139.208 27.6895C136.944 27.6895 135.108 29.5251 135.108 31.7895C135.108 34.0538 136.944 35.8895 139.208 35.8895Z",
    fill: "#EAEEF9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135.108 22.5893C136.654 22.5893 137.908 21.3357 137.908 19.7893C137.908 18.2429 136.654 16.9893 135.108 16.9893C133.561 16.9893 132.308 18.2429 132.308 19.7893C132.308 21.3357 133.561 22.5893 135.108 22.5893Z",
    fill: "#EAEEF9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7082 31.7895C23.2546 31.7895 24.5082 30.5358 24.5082 28.9895C24.5082 27.4431 23.2546 26.1895 21.7082 26.1895C20.1618 26.1895 18.9082 27.4431 18.9082 28.9895C18.9082 30.5358 20.1618 31.7895 21.7082 31.7895Z",
    fill: "#EAEEF9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.408 93.3893C18.2799 93.3893 20.608 91.0611 20.608 88.1893C20.608 85.3174 18.2799 82.9893 15.408 82.9893C12.5361 82.9893 10.208 85.3174 10.208 88.1893C10.208 91.0611 12.5361 93.3893 15.408 93.3893Z",
    fill: "#EAEEF9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.625 117.2L116.232 99.8407C97.8722 113.342 72.7002 100.178 72.7002 78.1418C72.7002 63.1455 84.9238 50.9941 99.9014 50.9941C121.546 50.9941 134.833 75.2969 122.223 93.6686L139.713 111.124C141.404 112.812 141.404 115.512 139.713 117.2C138.022 118.887 135.316 118.887 133.625 117.2ZM99.9014 59.6255C89.6586 59.6255 81.3002 67.9675 81.3002 78.19C81.3002 94.633 101.013 102.541 112.318 91.9809C125.122 80.0224 116.57 59.6255 99.9014 59.6255Z",
    fill: "#989FB0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M98.017 82.2399C97.9687 81.8541 97.9204 81.4683 97.9204 81.0344C97.9204 79.4431 98.5968 77.9965 100.288 76.7428L101.737 75.682C102.655 75.0069 103.042 74.2354 103.042 73.3192C103.042 71.9691 102.075 70.6671 100.046 70.6671C97.9204 70.6671 97.0024 72.3548 97.0024 74.0425C97.0024 74.38 97.0507 74.7176 97.099 75.0069L93.3305 74.8622C93.2339 74.4283 93.1855 73.9461 93.1855 73.5121C93.1855 70.2814 95.6013 67.1953 99.9979 67.1953C104.636 67.1953 107.052 70.0885 107.052 73.1263C107.052 75.4891 105.844 77.1286 104.105 78.3823L102.897 79.2502C101.834 79.9735 101.302 80.9379 101.302 82.1434V82.3363H98.017V82.2399ZM99.708 84.1686C101.013 84.1686 102.075 85.2295 102.075 86.5314C102.075 87.8333 101.013 88.8942 99.708 88.8942C98.4035 88.8942 97.3406 87.8333 97.3406 86.5314C97.3406 85.2295 98.4035 84.1686 99.708 84.1686Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13352_2005",
    x: 26.3408,
    y: 3.10254,
    width: 108.216,
    height: 126.174,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13352_2005"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13352_2005",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13352_2005",
    x: 0,
    y: 28.7783,
    width: 164.277,
    height: 113.612,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13352_2005"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13352_2005",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13352_2005",
    x1: 79.4855,
    y1: 30.5939,
    x2: 79.4855,
    y2: 67.7398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13352_2005",
    x1: 80.4277,
    y1: 12.2018,
    x2: 80.4277,
    y2: 97.1626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13352_2005",
    x1: 82.0995,
    y1: 38.1681,
    x2: 82.0995,
    y2: 110.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFile);
export default __webpack_public_path__ + "static/media/EmptyFile.6ab004b016a8d73bf630354254008bdf.svg";
export { ForwardRef as ReactComponent };